module.exports = __webpack_public_path__ + "static/img/title-hzsj.f54889d6.png";